/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddEditClientRequestDto } from '../../models/add-edit-client-request-dto';
import { GeneralResponse } from '../../models/general-response';

export interface ClientAddNewClientPost$Plain$Params {
      body?: AddEditClientRequestDto
}

export function clientAddNewClientPost$Plain(http: HttpClient, rootUrl: string, params?: ClientAddNewClientPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GeneralResponse>> {
  const rb = new RequestBuilder(rootUrl, clientAddNewClientPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeneralResponse>;
    })
  );
}

clientAddNewClientPost$Plain.PATH = '/Client/AddNewClient';
